import React from 'react';
import ChartFaultsTimeAndLocation from './Charts/ChartFaultsTimeAndLocation';

const TabFaultTrends = ({ hirarchy }) => {
  const props = {
    type: hirarchy.type.label,
    id: hirarchy.level.value,
  };

  return <ChartFaultsTimeAndLocation {...props} />;
};

export default TabFaultTrends;
